export default __webpack_public_path__ + "static/media/cancel-red.8286fd41.svg";